import React, { useEffect } from 'react'
import { toast, ToastItem } from 'react-toastify'
import ToastContainer from 'components/visualization/Toast/ToastContainer'

import { useAppDispatch } from 'app/hooks'
import { removeToastID, addToastID } from 'features/ui/uiSlice'

const ToastHandler = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const unsubscribe = toast.onChange((payload: ToastItem) => {
      if (payload.status === 'added') {
        dispatch(addToastID({ toastId: payload.id }))
      }
      if (payload.status === 'removed') {
        dispatch(removeToastID({ toastId: payload.id }))
      }
    })
    return () => {
      unsubscribe()
    }
  }, [dispatch])

  return <ToastContainer />
}

export default ToastHandler
